import { factorySetStateAction } from '../factory'

// Defined Device Constants to bind SAGA functions with Redux Dispatcher
const actions = {
  SET_STATE: 'alertSubscription/SET_STATE',
  GET_SUBSCRIPTION_LIST: 'alertSubscription/GET_SUBSCRIPTION_LIST',
  ADD_NUMBER: 'alertSubscription/ADD_NUMBER',
  DISABLE_SUBSCRIPTION: 'alertSubscription/DISABLE_SUBSCRIPTION',
}

export const disableSubscription = (payload) => ({
  type: actions.DISABLE_SUBSCRIPTION,
  payload,
})

export const alertSubscriptionSetState = factorySetStateAction(actions.SET_STATE)

export default actions
